export default __webpack_public_path__ + "static/media/rolaomodajaecoo-c5-hero-video.b49cb0e1.mp4";